module.exports = "/_next/static/images/a08206b625a5f1d54515fec9b3020d18-hero-desktop.jpg.webp";